import React from "react";
import { Section, Typography } from "../../../core";
import { useHistory } from "react-router-dom";
import { theme, MixStyle } from "../../../styles";
import styled from "styled-components";
import { FormOutlined } from "@ant-design/icons";
const { colors, textColor } = theme;
const Wraper = styled.div`
  ${MixStyle.flexBetween}
  span {
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: #404e67;
  }
  svg {
    width: 20.12px;
    height: 20.12px;
    color: ${colors.Fiord};
    margin: 0px 5px;
  }
`;
const typoProps = {
  as: "p",
  weight: "500",
  fontSize: "16px",
  lineHeight: "24px",
  color: "#404E67",
  align: "justify",
};

export const Note = ({ description, contractId, contractNo, contractType }) => {
  let history = useHistory();
  const editContractHandler = () => {
    history.push({
      pathname: `/edit/${
        contractType === "fabric" ? "fabric-contract" : "conversion-contract"
      }/${contractNo}`,
      state: contractId,
    });
  };

  return (
    <Section padding="20px" minheight="100%">
      <Wraper>
        <Typography
          color={textColor.primary}
          letterSpacing="0.2"
          weight="bold"
          as="h3"
        >
          Note :
        </Typography>
        <div>
          {/* <Link
            to={`/edit/${
              contractType === "fabric"
                ? "fabric-contract"
                : "conversion-contract"
            }/${contractId}`}
          > */}
          <FormOutlined color="#404E67" onClick={editContractHandler} />
          {/* </Link> */}

          <span>Edit</span>
        </div>
      </Wraper>
      <Typography {...typoProps}>{description ? description : ""}</Typography>
    </Section>
  );
};
